import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import T from "../styles/tokens";
import { Ic } from "./UI";

const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: Ic.Dashboard, path: "/dashboard" },
  { key: "clients", label: "Clients", icon: Ic.Clients, path: "/dashboard/clients" },
  { key: "invite", label: "New Invitation", icon: Ic.Invite, path: "/dashboard/invite" },
  { key: "audit", label: "Audit Log", icon: Ic.Audit, path: "/dashboard/audit" },
];

export default function Sidebar({ open = true, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const handleLogout = () => {
    instance.logoutRedirect({
      account,
      postLogoutRedirectUri: window.location.origin,
    });
  };

  const isActive = (path) => {
    if (path === "/dashboard") return location.pathname === "/dashboard";
    return location.pathname.startsWith(path);
  };

  const navigateAndClose = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <div className={`pf-sidebar${open ? " pf-open" : ""}`} style={{
      width: 220, height: "100vh", background: T.indigo,
      display: "flex", flexDirection: "column",
      position: "fixed", left: 0, top: 0, zIndex: 100,
    }}>
      {/* Logo */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "18px 18px 14px",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}>
        <img
          src="/Big_P.jpg"
          alt="Pathfinder"
          width={32}
          height={32}
          style={{ width: 32, height: 32, objectFit: "contain", flexShrink: 0, borderRadius: 6, display: "block" }}
        />
        <div>
          <div style={{ color: T.white, fontSize: 13, fontWeight: 700, fontFamily: T.font, lineHeight: 1.2 }}>Pathfinder</div>
          <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 9.5, fontWeight: 500, fontFamily: T.font, letterSpacing: "0.05em" }}>CLIENT ONBOARDING</div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ padding: "12px 8px", flex: 1 }}>
        {NAV_ITEMS.map(({ key, label, icon: Icon, path }) => {
          const active = isActive(path);
          return (
            <button
              key={key}
              onClick={() => navigateAndClose(path)}
              style={{
                width: "100%",
                display: "flex", alignItems: "center", gap: 10,
                padding: "10px 12px", marginBottom: 2,
                borderRadius: T.radiusSm,
                background: active ? "rgba(255,255,255,0.12)" : "transparent",
                color: active ? T.white : "rgba(255,255,255,0.55)",
                border: "none", cursor: "pointer",
                fontSize: 13, fontWeight: active ? 600 : 500,
                fontFamily: T.font,
                transition: "all 0.15s",
              }}
            >
              <Icon />
              {label}
            </button>
          );
        })}
      </nav>

      {/* Account + Logout */}
      <div style={{
        padding: "10px 12px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}>
        {account && (
          <div style={{
            color: "rgba(255,255,255,0.55)",
            fontSize: 11, fontFamily: T.font,
            padding: "4px 12px 8px",
            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          }}>
            {account.name || account.username}
          </div>
        )}
        <button
          onClick={handleLogout}
          style={{
            width: "100%",
            display: "flex", alignItems: "center", gap: 10,
            padding: "10px 12px",
            borderRadius: T.radiusSm,
            background: "transparent",
            color: "rgba(255,255,255,0.55)",
            border: "none", cursor: "pointer",
            fontSize: 13, fontWeight: 500, fontFamily: T.font,
            transition: "all 0.15s",
          }}
        >
          Sign out
        </button>
      </div>

      {/* Footer */}
      <div style={{
        padding: "14px 18px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        color: "rgba(255,255,255,0.3)",
        fontSize: 10, fontFamily: T.font,
      }}>
        Pathfinder Technical Services
        <br />v1.0.0
      </div>
    </div>
  );
}
